exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul.social_button[data-v-31e1b5c4]{padding:0}ul.social_button li[data-v-31e1b5c4]{display:inline;margin-right:20px;cursor:pointer}.align[data-v-31e1b5c4]{margin-top:50px;margin-right:-50%;margin-left:75%}@media (max-width:768px){.align[data-v-31e1b5c4]{margin-right:0;margin-left:0}}.alignTop[data-v-31e1b5c4]{margin-top:50px}.alignVideos[data-v-31e1b5c4]{margin-top:50px;margin-right:-50%;margin-left:55%}@media (max-width:768px){.alignVideos[data-v-31e1b5c4]{margin-right:0;margin-left:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-31e1b5c4","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/front/Buttons.vue
// module id = gFWT
// module chunks = 75